import type { Config } from 'driver.js';

export const DEFAULT_DRIVER_CONFIG: Partial<Config> = {
  allowClose: true,
  disableActiveInteraction: true,
  overlayOpacity: 0.3,
  stagePadding: 0,
  animate: true,
  showProgress: true,
  smoothScroll: true,
  allowKeyboardControl: true,
  popoverClass: 'sf-tour-popover',
  overlayColor: 'black',
  nextBtnText: 'Next →',
  prevBtnText: '← Previous',
  doneBtnText: 'Done',
};

export const GLOSSARY_HIGHLIGHT_CONFIG: Partial<Config> = {
  ...DEFAULT_DRIVER_CONFIG,
  showProgress: false,
  overlayOpacity: 0.1,
};
